import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import i18n from "@/plugins/vue-i18n.js";
import { currencies } from "@/i18n/index.js";

export function numberFormat(number, key = "", displayZero = false, siteCurrency) {
  var s = number;
  try {
    switch (key) {
      case dimensionEnum.OMNIPLAYEVENT_REFERENCE:
      case dimensionEnum.OMNIPLAYEVENT_INVOICENUMBER:
        return s;
      case mesureEnum.PURCHASEHISTORY_AMOUNT:
      case mesureEnum.PURCHASEHISTORY_AMOUNTCB:
      case mesureEnum.PURCHASEHISTORY_AMOUNTCASH:
      case mesureEnum.GAMEHISTORY_TOKEN_PRICE:
      case mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT:
      case alternativeColumnLabelEnum.GAMEHISTORY_TOKEN_PRICE:
      case alternativeColumnLabelEnum.GAMEHISTORY_TOKEN_PRICE_HT:
      case mesureEnum.GAMEHISTORY_TOTAL_VAT:
      case mesureEnum.SNACKHISTORY_TOKEN_PRICE:
      case mesureEnum.SNACKHISTORY_TOKEN_PRICE_HT:
      case mesureEnum.SNACKHISTORY_TOTAL_VAT:
      case mesureEnum.STAFFGAMEHISTORY_REVENUE_EQUIVALENT_TTC:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_TOTAL:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT2:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_CB:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_CASH:
      case calculatedColumnsEnum.REVENUE_EQUIVALENT_TTC:
      case calculatedColumnsEnum.REVENUE_EQUIVALENT_HT:
      case calculatedColumnsEnum.REVENUE_TTC:
      case calculatedColumnsEnum.REVENUE_HT:
      case calculatedColumnsEnum.REVENUE_TVA:
      case calculatedColumnsEnum.TOTAL_DATA:
      case calculatedColumnsEnum.TOTAL_DATA_HT:
      case calculatedColumnsEnum.TOTAL_DATA_TAXES:
      case calculatedColumnsEnum.INVOICE_AMOUNT_PERIOD1:
      case calculatedColumnsEnum.INVOICE_AMOUNT_PERIOD2:
      case calculatedColumnsEnum.INVOICE_AMOUNT_HT_PERIOD1:
      case calculatedColumnsEnum.INVOICE_AMOUNT_HT_PERIOD2:
      case calculatedColumnsEnum.TOTAL_EURO:
      case calculatedColumnsEnum.AVERAGE_BASKET:
      case calculatedColumnsEnum.REVENUE_TTC_LONG:
      case calculatedColumnsEnum.REVENUE_HT_LONG:
      case calculatedColumnsEnum.TTC_DIFFERENCE:
      case calculatedColumnsEnum.TOTAL:
      case calculatedColumnsEnum.DIFF_REVENUE:
      case calculatedColumnsEnum.RUNNINGTOTALS_TTC_DIFFERENCE:
      case mesureEnum.VFULLHOURLYACCOUNTING_EXTRA_REVENUE:
      case mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC:
      case calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT:
      case alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC:
      case alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC2:
      case dimensionEnum.OMNIPLAYEVENT_CREDIT:
      case dimensionEnum.OMNIPLAYEVENT_DEBIT:
      case mesureEnum.OMNIPLAYEVENT_TOTALTTC:
      case calculatedColumnsEnum.TOTAL_DATA_TTC:
      case calculatedColumnsEnum.TOTAL_REVENUE_5:
      case calculatedColumnsEnum.TOTAL_REVENUE_10:
      case calculatedColumnsEnum.TOTAL_REVENUE_20:
      case calculatedColumnsEnum.NOT_SPENT:
      case mesureEnum.AZURECOST_EQUIVALENT_TRANSACTION:
      case mesureEnum.PURGEHISTORY_CA_GENERATED:
      case mesureEnum.SNACKHISTORY_EQUIVALENT_EURO_WITHOUTCB:
        s = formatAmount(number, displayZero, siteCurrency);
        break;
      case calculatedColumnsEnum.POPULARITY:
      case mesureEnum.PURGEHISTORY_TOKEN_PRICE:
        s = formatRoundFiveDecimal(number);
        break;
      case dimensionEnum.DATE_MONTH:
        s = i18n.t(`Months.${number}`);
        break;
      case dimensionEnum.DATE_DAYOFWEEK:
        s = i18n.t(`DayOfWeek.${number}`);
        break;
      case dimensionEnum.TIME_HOUR:
        s = number.toString().length == 1 ? `0${number}` : number.toString();
        s += "h00";
        break;
      case calculatedColumnsEnum.HOUR_PERIOD:
        s = formatHourPeriod(number);
        break;
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_SNACK:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_MERCHANDISING:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_GAME:
      case calculatedColumnsEnum.TAXES_PERCENTAGE:
      case calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE:
      case calculatedColumnsEnum.PERCENT_TOTAL_CB:
      case calculatedColumnsEnum.PERCENT_TOTAL_CASH:
      case calculatedColumnsEnum.PERCENT_PER_KIOSK_PERIOD1:
      case calculatedColumnsEnum.PERCENT_PER_KIOSK_PERIOD2:
      case calculatedColumnsEnum.PERCENT_PER_GAME_PERIOD1:
      case calculatedColumnsEnum.PERCENT_PER_GAME_PERIOD2:
      case calculatedColumnsEnum.PERCENT_REVENUE_PER_GAME:
      case calculatedColumnsEnum.PERCENT_TOKENS_PER_GAME:
      case calculatedColumnsEnum.PERCENT_REVENUE_PER_SNACK:
      case calculatedColumnsEnum.PERCENT_TOKEN:
      case calculatedColumnsEnum.PERCENT_BONUS_TOKEN:
      case calculatedColumnsEnum.BONUS_TOKENS_RATIO:
      case calculatedColumnsEnum.PERCENT_TOKEN_NOT_CONSUMED:
      case dimensionEnum.GAMEHISTORY_TAXESPERCENT:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_5:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_10:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_20:
      case mesureEnum.AZURECOST_PERCENT_TRANSACTION:
        s = formatPercentage(number, displayZero);
        break;
      case calculatedColumnsEnum.COMPARE_INVOICE_AMOUNTS:
      case calculatedColumnsEnum.COMPARE_INVOICE_AMOUNTS_HT:
        s = formatPercentageProgression(number);
        break;
      case calculatedColumnsEnum.COMPARE_REVENUE_PERCENT:
        s = formatNumberProgression(number);
        break;
      case "timeRangePicker":
        s = `${number}h`;
        break;
      case dimensionEnum.GAME_TOKENPRICEASDIMENSION:
        if (number === null) {
          s = "";
        } else {
          s = number + i18n.t("Display.unitSuffix");
        }
        break;
      case mesureEnum.VSMARTTOUCHMAINTENANCE_DURATION_SUM:
        s = formatDayHourMinute(number);
        break;
      default:
        if (
          key.startsWith(mesureEnum.VFULLHOURLYACCOUNTING_AMOUNT_HT) ||
          key.startsWith(calculatedColumnsEnum.TOTAL_DYNAMIC_TAXES)
        ) {
          s = formatAmount(number, displayZero, siteCurrency);
        } else {
          s = separateThousands(number, displayZero);
        }
        break;
    }
  } catch (error) {
    console.log(error);
  }
  return s;
}

export function formatAmount(number, displayZero = false, siteCurrency) {
  const roundNumber = number ? round(number) : 0;
  return Math.abs(roundNumber) !== 0 || displayZero
    ? separateThousands(roundNumber.toFixed(2)) + " " + (currencies[siteCurrency] || '€')
    : "";
}

const round = (n) =>
  n != null && n !== undefined ? Math.round(n * 100) / 100 : null;

function separateThousands(number, displayZero = true) {
  if (number === 0 && !displayZero) return null;
  return number
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    : number;
}

export function formatPercentage(number, displayZero = false) {
  return (number && number !== 0) || displayZero
    ? separateThousands(Number(number).toFixed(2)) + " %"
    : "";
}

function formatPercentageProgression(number) {
  if (number && number !== 0) {
    return number > 0
      ? `+ ${formatPercentage(number, false)}`
      : `- ${formatPercentage(number * -1, false)}`;
  } else {
    return "=";
  }
}

function formatNumberProgression(number) {
  if (number && number !== 0) {
    if (number > 0) return `+ ${separateThousands(number.toFixed(2))}`;
    else {
      const value = number * -1;
      return `+ ${separateThousands(value.toFixed(2))}`;
    }
  } else {
    return "=";
  }
}

function formatHourPeriod(number) {
  const nextNumber = number == 23 ? 0 : number + 1;
  var s = number.toString().length == 1 ? `0${number}` : number.toString();
  s += "h - ";
  s +=
    nextNumber.toString().length == 1
      ? `0${nextNumber}`
      : nextNumber.toString();
  s += "h";
  return s;
}

function formatDayHourMinute(value) {
  return `${Math.floor(value / 1440)} jour(s) ${Math.floor(
    (value % 1440) / 60
  )} heure(s) ${value % 60} minute(s)`;
}

function formatRoundFiveDecimal(number) {
  return (Math.round(number * 100000) / 100000).toFixed(5);
}
